import _get from "lodash/get";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { PersonalDetailsState } from "../../../../models/state";
import { fulfilled } from "../../app/utils";

const initialState: PersonalDetailsState = {
    submitOrderSuccess: false,
};

const reducer = (state = initialState, action: AnyAction): PersonalDetailsState => {
    switch (action.type) {
        case fulfilled(AT.FWA_UPDATE_CUSTOMER_AND_SUBMIT):
            return {
                ...initialState,
                submitOrderSuccess: _get(action, "payload.success", false),
            };
        default:
            return state;
    }
};

export default reducer;
